import {alignDivHeights} from "../../../../orange/broadband/utils/AlignDivHeightsUtil";
import AlertDiscount from "../../../ob1/component/AlertDiscount.vue";
import SwiperContainer from "../../../../common/components/vue/swiper/SwiperContainer.vue";
import SwiperSlide from "../../../../common/components/vue/swiper/SwiperSlide.vue";
import VariationCard from "./component/VariationCard.vue";

const root = document.getElementById("tvPackageDetailPage");
const listOfDivToAlign = [
    "internet-banner", "bloc-title", "bloc-attributs", "separator-before-price",
    "bloc-price", "bloc-price-mentions", "bloc-button",
];

window.app = new Vue({
    el: root,
    name: "TvPackageDetailPage",
    components: {
        AlertDiscount,
        SwiperContainer,
        SwiperSlide,
        VariationCard,
    },
    data: {
        pageVue: JSON.parse(root.dataset.dto),
        swiperSlidesPerView: 1.15,
        swiperSpaceBetween: 30,
        swiperNavigation: true,
        swiperUpdateNavigationPositionInScreen: true,
        swiperBreakpointsDisplayingFiveSlidesOrMore: {
            // when window width is <= 480px
            480: {
                slidesPerView: 1.25
            },
            // when window width is <= 560px
            560: {
                slidesPerView: 1.6
            },
            // when window width is >= 736px
            736: {
                slidesPerView: 2.5
            },
            // when window width is >= 960px
            960: {
                slidesPerView: 3.2
            },
            // when window width is XL >= 1200px
            1200: {
                slidesPerView: 3.5
            },
            // when window width is >= 1280px
            1280: {
                slidesPerView: 3.8
            },
            // when window width is >= 1400px
            1400: {
                slidesPerView: 4.2
            }
        },
        swiperBreakpointsDisplayingFourSlides: {
            // when window width is >= 560px
            560: {
                slidesPerView: 1.6
            },
            // when window width is >= 736px
            736: {
                slidesPerView: 2.5
            },
            // when window width is >= 960px
            960: {
                slidesPerView: 3.2
            },
            // when window width is >= 1200px
            1200: {
                slidesPerView: 4
            }
        },
        swiperBreakpointsDisplayingThreeSlides: {
            // when window width is >= 560px
            560: {
                slidesPerView: 1.6
            },
            // when window width is >= 736px
            736: {
                // slidesPerView: 1.8
                slidesPerView: 2.5
            },
            // when window width is >= 960px
            960: {
                slidesPerView: 3
            },
            // when window width is >= 1200px
            1200: {
                slidesPerView: 4
            },
        },
    },
    computed: {
        variationsContainer: function() {
            return this.pageVue.variationsContainer
        },
        headerNoVariation: function() {
            return this.pageVue.header.detainedVariation === false ? this.pageVue.header : null
        },
        swiperBreakpoints() {
            if (this.variationsContainer?.variationsCards?.length >= 5) {
                return this.swiperBreakpointsDisplayingFiveSlidesOrMore;
            } else if (this.variationsContainer?.variationsCards?.length === 4) {
                return this.swiperBreakpointsDisplayingFourSlides;
            } else {
                return this.swiperBreakpointsDisplayingThreeSlides;
            }
        },
    },
    mounted() {
        alignDivHeights(listOfDivToAlign);
        window.addEventListener("resize", () => {
            alignDivHeights(listOfDivToAlign)
        });
    },
    updated() {
        alignDivHeights(listOfDivToAlign);
    },
});

(function initApp() {

    (function () {

        /** JS Affichage chaines **/

        const channelElemSelector = ".elt-chaine";
        const channelElemActiveClass = "active";
        const clonedChannelInfoSelector = ".infos-chaine.cloned";
        const channelElemList = Array.from(document.querySelectorAll(channelElemSelector));

        function scrollTo(target, durationMs) {
            $("html, body").animate({scrollTop: target.offset().top}, durationMs);
        }

        function findJqActiveChannel() {
            const activeChannel = channelElemList.find(
                (channelElem) => channelElem.classList.contains(channelElemActiveClass)
            );
            return activeChannel === undefined
                ? undefined
                : $(activeChannel);
        }

        function openInfosChaine($channelElem) {

            const $channelInfo = $channelElem.find(".infos-chaine");
            const $arrow = $channelInfo.find(".arrow");
            const $figure = $channelElem.find("figure:first-child");
            const leftValue = (function () {
                if ($(window).width() >= 960) {
                    const offsetContainer = $channelElem.parents(".d-flex").offset().left;
                    return ($figure.offset().left - offsetContainer) + $figure.width() / 2 - $arrow.width();
                }
                return $figure.offset().left + $figure.width() / 2 - ($arrow.width() + $arrow.width() / 2);
            }());

            $arrow.css({left: leftValue});

            $channelInfo
                .clone()
                .addClass("cloned")
                .css({
                    top: $channelElem.offset().top
                        - $channelElem.parents(".d-flex").offset().top
                        + $channelElem.outerHeight(true),
                    zIndex: 1
                })
                .insertAfter($channelElem);

            const $cloned = $(clonedChannelInfoSelector);

            const initialChannelHeight = $channelElem.outerHeight(true);

            $channelElem.addClass("active").css({height: $cloned.outerHeight(true) + initialChannelHeight});

            $cloned.fadeIn(400, function () {
                scrollTo($channelElem, 400);
                $channelElem.css({height: $cloned.outerHeight(true) + initialChannelHeight});
            });
        }

        function closeInfosChaine($activeChannelElem, callback) {

            const $clonedChannelInfo = $(clonedChannelInfoSelector);
            $clonedChannelInfo.fadeOut(400, function () {
                $activeChannelElem.removeAttr("style").removeClass(channelElemActiveClass);
                $clonedChannelInfo.remove();
                if (typeof callback === "function") {
                    callback.call();
                }
            });
        }

        function closeAnyChannelInfo() {
            const $activeChannel = findJqActiveChannel();
            if ($activeChannel !== undefined) {
                closeInfosChaine($activeChannel);
            }
        }

        function onClickLogoChaine(jqEvent) {
            const clickedChannelElem = $(jqEvent.currentTarget).parent(channelElemSelector)[0];
            const $clickedChannelElem = $(clickedChannelElem);
            if (clickedChannelElem.classList.contains(channelElemActiveClass)) {
                closeInfosChaine($clickedChannelElem);
            } else {
                const $activeChannel = findJqActiveChannel();
                if ($activeChannel !== undefined) {
                    // si une autre est ouverte, on la fadeout, puis on l'inactive, puis on ouvre la nouvelle
                    closeInfosChaine($activeChannel, function () {
                        openInfosChaine($clickedChannelElem);
                    });
                } else {
                    // sinon, on ouvre la nouvelle tout de suite
                    openInfosChaine($clickedChannelElem);
                }
            }
        }

        function onResizeFn(width) {
            return function () {
                const newWidth = $(window).width();
                if (newWidth !== width) {
                    closeAnyChannelInfo();
                    alignDivHeights(listOfDivToAlign);
                    $(window).off("resize").resize(onResizeFn(newWidth));
                    setTimeout(setHeaderHeight(), 400);
                }
            };
        }

        function setHeaderHeight() {
            const textHeader = document.getElementById('header-text');
            const imgHeader = document.getElementById('header-img');
            const image = document.getElementsByClassName('headerImage')[0];

            image.onerror = function(){
                document.getElementById('header-content').classList.add("bg-dark");
            };

            document.getElementById('header-content').style.minHeight = textHeader.clientHeight + "px";
        }

        $(".logo-chaine").click(onClickLogoChaine);
        $("body").on("click", clonedChannelInfoSelector, function (jqEvent) {
            if (jqEvent.target.tagName !== "A") {
                closeAnyChannelInfo();
            }
        });
        $(window).resize(onResizeFn($(window).width()));

        $(document).ready(function () {
            setTimeout(setHeaderHeight(), 400);
        });

    }());

}());
